module.exports = __webpack_public_path__ + "img/hero-login.48e12382.svg";